import React from 'react';

const Required = () => {
    return(<span className='text-red-500 font-bold'>*</span>)
}

export default Required;
